<template>
  <v-dialog v-model="showDialog" persistent max-width="800">
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title">Edição de Evento</slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="close()" color="white">mdi-window-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col sm="6">
            <v-text-field v-model="payload.nome"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field
              v-model="payload.inicioString"
              v-mask="'##/##/#### ##:##'"
              label="Data de Início"
              placeholder="00/00/0000 00:00"
            ></v-text-field>
          </v-col>

          <v-col>
            <v-text-field
              v-model="payload.fimString"
              v-mask="'##/##/#### ##:##'"
              label="Data de Término"
              placeholder="00/00/0000 00:00"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col md="9" sm="9" lg="9">
            <v-combobox
              v-model="payload.municipios"
              :items="municipios"
              chips
              clearable
              :label="isGov ? 'Projetos' : 'Municípios'"
              item-text="nome"
              item-value="municipioId"
              multiple
            >
            </v-combobox>
          </v-col>
          <v-col>
            <v-btn color="info" outlined text @click="selecionarTodos()"
              >Selecionar Todos</v-btn
            >
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-textarea
              label="Observações"
              v-model="payload.observacoes"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="close()">Fechar</v-btn>
        <v-btn color="info" outlined text @click="save()">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { cityAPI } from "@/modules/city";
import { eventAPI } from "@/modules/event";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppModalEditEvent",
  props: {
    dialogEdicao: { type: Boolean, default: false },
    payload: { type: Object },
  },
  computed: {
    ...mapGetters(["isAT", "isGov"]),
  },
  data() {
    return {
      menu: "",
      menu2: "",
      date: null,
      time: null,
      showDialog: this.dialogEdicao,
      municipios: [],
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    save() {
      this.setLoading(true);
      eventAPI
        .update(this.payload)
        .then((resp) => {
          this.$emit("onSave");
          this.showDialog = false;
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error(
            `Erro ao atualizar ${this.isAT ? "agenda" : "encontro"}`
          );
        });
    },
    loadCities() {
      this.setLoading(true);
      cityAPI
        .listNames()
        .then((resp) => {
          this.municipios = resp.data;
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter municípios");
        });
    },
    close() {
      this.$emit("closeDialog");
    },
    selecionarTodos() {
      this.payload.municipios = this.municipios;
    },
  },
  watch: {
    dialogEdicao(value) {
      this.showDialog = value;
    },
  },
  created() {
    this.loadCities();
  },
};
</script>
